import {peakAlert, peakConfirm} from "../../PeakDialog.js";
import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery;


export class ZIDXAccountCrawlQueue implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCrawlQueueContainer";
    }
    render(){
        // console.log("Crawl Queue");

        $(".zidxAccountCrawlQueueContainer .retryFailedButton", this.zidx.peakidxShadowRoot).on("click", async function(this:HTMLElement, e){
            e.preventDefault();
            if(await peakConfirm("Are you sure you want to retry failed URLs?")) {
                $.get((this as HTMLAnchorElement).href, {}, function (data) {
                    if (data.success) {
                        // alert("Retrying failed URLs");
                    } else {
                        peakAlert("Failed to retry URLs: " + data.errorMessage);
                    }
                });
            }
        });
        $(".zidxAccountCrawlQueueContainer .clearCompletedButton", this.zidx.peakidxShadowRoot).on("click", async function(this:HTMLElement, e){
            e.preventDefault();
            if(await peakConfirm("Are you sure you want to clear completed URLs?")) {
                $.get((this as HTMLAnchorElement).href, {}, function (data) {
                    if (data.success) {
                        peakAlert("Crawl queue cleared");
                    } else {
                        peakAlert("Failed to clear crawl queue: " + data.errorMessage);
                    }
                });
            }
        });
    }
}
